// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5":"88fd726d","14":"88fd726d","19":"88fd726d","503":"88fd726d","534":"88fd726d","857":"88fd726d","984":"88fd726d"}[chunkId] + ".chunk.css";
};